import { useCallback } from 'react';
import {
  KoForm,
  KoFormBuilder,
  KoSelect,
  KoInput,
  KoTextArea
} from 'packages';
import { QA_TYPE_OPTIONS } from '../../constants';
import styles from './crud.module.scss';

function QACrud({ form, handleFinish, initialValues, testerOptions = [], ticketOptions = [] }) {
  const handleSubmit = useCallback((values) => {
    handleFinish(values);
  }, [handleFinish]);

  const TicketWidget = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={(v) => onChange(v)}
      showSearch
      placeholder='Link to Kwapio ticket'
      options={ticketOptions}
    />
  );

  const TypeWidget = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={(v) => onChange(v)}
      placeholder='Test type'
      options={QA_TYPE_OPTIONS}
    />
  );

  const TesterWidget = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={(v) => onChange(v)}
      showSearch
      placeholder='Assign tester'
      options={testerOptions}
    />
  );

  const EnvWidget = ({ value, onChange }) => (
    <KoSelect
      value={value}
      onChange={(v) => onChange(v)}
      placeholder='Environment'
      options={[
        { label: 'Development', value: 'development' },
        { label: 'QA', value: 'qa' },
        { label: 'UAT', value: 'uat' },
        { label: 'Production', value: 'production' }
      ]}
    />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues,
    colon: true,
    fields: [
      {
        key: 'ticketId',
        label: 'Kwapio Ticket',
        colSpan: 2,
        widget: TicketWidget,
        forwardRef: true,
        required: true,
        rules: [{ required: true, message: 'Please link a ticket' }]
      },
      {
        key: 'type',
        label: 'Test Type',
        colSpan: 1,
        widget: TypeWidget,
        forwardRef: true
      },
      {
        key: 'assignedTo',
        label: 'Tester',
        colSpan: 1,
        widget: TesterWidget,
        forwardRef: true
      },
      {
        key: 'title',
        label: 'Test Case Title',
        colSpan: 4,
        widget: KoInput,
        widgetProps: {
          placeholder: 'e.g. Payment fails gracefully on network timeout without double-charge'
        }
      },
      {
        key: 'environment',
        label: 'Environment',
        colSpan: 2,
        widget: EnvWidget,
        forwardRef: true
      },
      {
        key: 'steps',
        label: 'Steps to Reproduce / Test Instructions',
        colSpan: 4,
        widget: KoTextArea,
        widgetProps: {
          placeholder: '1. Navigate to...\n2. Click...\n3. Assert...',
          rows: 4
        }
      }
    ]
  };

  return (
    <div className={styles.wrapper}>
      <KoForm
        form={form}
        layout='vertical'
        onFinish={handleSubmit}
        onSubmit={handleSubmit}
      >
        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
}

export default QACrud;
